import React from 'react';
import { TextField } from '@mui/material';
import GridSelect from './GridSelect';

// Drop-in for <TextField select>{MenuItems}</TextField>: lists with 7+ options become a searchable grid; small lists stay a normal dropdown.
const flatten = (children) => {
    const out = [];
    React.Children.forEach(children, (ch) => {
        if (!ch) return;
        if (ch.type === React.Fragment) out.push(...flatten(ch.props.children));
        else out.push(ch);
    });
    return out;
};
const textOf = (n) => (typeof n === 'string' || typeof n === 'number' ? String(n) : Array.isArray(n) ? n.map(textOf).join('') : n && n.props ? textOf(n.props.children) : '');

export default function GridSelectField(props) {
    const { children, name, value, onChange, label, error, helperText, disabled, SelectProps, minForGrid = 7, gridColumns, select, ...rest } = props;
    const items = flatten(children).filter((ch) => ch && ch.props && ch.props.value !== undefined);
    const options = items.filter((ch) => ch.props.value !== '' && !ch.props.disabled).map((ch) => ({ value: ch.props.value, label: textOf(ch.props.children) }));
    if ((SelectProps && SelectProps.multiple) || options.length < minForGrid) {
        return (
            <TextField select name={name} value={value} onChange={onChange} label={label} error={error} helperText={helperText} disabled={disabled} SelectProps={SelectProps} {...rest}>
                {children}
            </TextField>
        );
    }
    return (
        <GridSelect
            label={label}
            value={value}
            options={options}
            columns={gridColumns}
            error={error}
            helperText={helperText}
            disabled={disabled}
            placeholder="Search…"
            onChange={(v) => onChange && onChange({ target: { name, value: v }, persist: () => {} })}
        />
    );
}
